import { OtsStaffOrderStatus } from '../types';

export const OTS_STAFF_STATUS_LABELS: Record<OtsStaffOrderStatus, readonly [string, string]> = {
  new: ['New', 'ots.staff.status.new'],
  preparing: ['Preparing', 'ots.staff.status.preparing'],
  ready: ['Ready', 'ots.staff.status.ready'],
  done: ['Done', 'ots.staff.status.done']
};
